import i18next from 'i18next';
import { centralApprovalStatus } from './CentralApprovalStatusHelper';
import { format, formatDate } from '@utils';

export const cancellableStatus = {
    CANCELLABLE: 'O',
    PAST_START_DATE:  'D',
    REPLACEMENT_CHOSEN: 'R',
    APPLICATION_CLOSED_OR_PAST_START_DATE: 'X',
    NOT_CANCELLABLE: 'N',
};

export function getCentralApprovalCancellableStatusDescription(key, status, applicantName, creationDate, description) {
    switch (key) {
        case cancellableStatus.CANCELLABLE:
            if (status == centralApprovalStatus.OPENED) {
                return format(i18next.t("approvalCentral:message.cancelation.approveApprobationConfirmationQuestion"), applicantName, i18next.t("approvalCentral:message.cancelation.approbationRequestConfirmationCreatedOn"), formatDate(creationDate, 'date'));
            } else {
                return format(i18next.t("approvalCentral:message.cancelation.cancelDemand"), description);
            }            
        case cancellableStatus.PAST_START_DATE:
            return i18next.t("approvalCentral:message.cancelation.startDatePassedError");
        case cancellableStatus.REPLACEMENT_CHOSEN:
            return i18next.t("approvalCentral:message.cancelation.substituteAssignedError");
        case cancellableStatus.NOT_CANCELLABLE:
            return i18next.t("approvalCentral:message.cancelation.cannotCancelError");
        default:
            return ``;
    }
}